class CrossHouseRelations {
  constructor() {
    this._houses = new Map(); // [houseId, Set<ParentRoom | ChildRoom>]
  }

  get houses() {
    return this._houses;
  }

  addRoom(houseId, room) {
    if (!this._houses.has(houseId)) {
      this._houses.set(houseId, new Set());
    }

    this._houses.get(houseId).add(room);
  }

  deleteRoom(houseId, room) {
    const rooms = this._houses.get(houseId);

    if (!rooms) return;

    rooms.delete(room);

    if (rooms.size === 0) {
      this._houses.delete(houseId);
    }
  }
}

export default CrossHouseRelations;
